export enum SHIPMENT_VIEW {
    TILE = "tile",
    GRID = "grid",
    REVIEW = "shipment",
}
